import { Component, OnInit } from '@angular/core';
import { ApplicationBase } from 'src/app/base/application-base';
import { IWindowContent } from 'src/app/interfaces/os/window-content.interface';
import { AuthService } from 'src/app/services/auth/auth.service';
import { WindowsManagerService } from 'src/app/services/os/windows-manager.service';
import { ThemeService } from 'src/app/services/ux/theme.service';

@Component({
  selector: 'main-application',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent extends ApplicationBase implements IWindowContent, OnInit {
  operation = "0";

  constructor(
    private windowsSv: WindowsManagerService,
    public theme: ThemeService) {
    super();
  }

  ngOnInit(): void {
  }

  start(data: any, windowId: number) {
    this.windowsSv.setTitle(windowId, "Calculator");
  }

  numb(n) {
    if (this.operation === "0") {
      this.operation = "";
    }

    this.operation += "" + n;
  }

  plus() {
    this.operation += "+";
  }

  minus() {
    this.operation += "-";
  }

  dot() {
    if (!this.operation.includes(".")) {
      if (this.operation === "") {
        this.operation += "0";
      }
      this.operation += ".";
    }
  }

  divide() {
    this.operation += "/";
  }

  mult() {
    this.operation += "*";
  }

  eval() {
    this.operation = eval(this.operation);
  }

  clear(m: boolean) {
    this.operation = "0";
  }
}
